
import { createReducer, on } from '@ngrx/store';
import { ListMemberState } from '../../models/list-members/list-member-state';
import * as listMemberAction from './list-members.actions';

export const listMemberKey = 'listMember';

export const initialState: ListMemberState = {
  members: null,
  isLoaded: false,
  isLoading: false,
};

export const listMemberReducer = createReducer(
  initialState,
  on(listMemberAction.listMembersSearch, (state) => ({
    ...state,
    isLoading: true,
    isLoaded: false
  })),
  on(listMemberAction.listMembersSearchSuccess, (state, response) => ({
    ...state,
    members: response.memberList,
    isLoading: false,
    isLoaded: false
  })),
  on(listMemberAction.listMemberReset, () => ({
    ...initialState
  }))
);
